import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth()
  const location = useLocation()

  // Preserve full path including query params for redirect after login
  const fullPath = location.pathname + location.search

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-ginger-500"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: fullPath }} replace />
  }

  // TFA is mandatory - if not enabled, force setup
  if (!user.tfa_enabled) {
    return <Navigate to="/setup-tfa" state={{ from: fullPath }} replace />
  }

  // If TFA enabled but not verified this session, redirect to login
  if (user.tfa_enabled && !user.tfa_verified) {
    return <Navigate to="/login" state={{ from: fullPath }} replace />
  }

  return <>{children}</>
}
